// import i18n from '@/plugins/i18n'

export default [
  // {
  //   path: 'wallet',
  //   name: 'wallet',
  //   component: () => import('@/app/M2001Coins/PgWallet'),
  //   meta: { authenticated: true, permissions: ['wallet.viewOwn'] }
  // },
  {
    path: 'toStripe',
    name: 'M2001CoinsToStripe',
    component: () => import('@/app/M2001Coins/PgToStripe'),
    portalGroup: 'all.public',
    meta: { authenticated: true }
  },
  {
    path: 'topup',
    name: 'topup',
    component: () => import('@/app/M2001Coins/PgTopup'),
    portalGroup: 'all.public',
    meta: { authenticated: true, permissions: ['wallet.viewOwn'] }
  },
  {
    path: 'CashFlowHistory',
    name: 'PgCashFlowHistory',
    component: () => import('@/app/M2001Coins/comps/PgCashFlowHistory.vue'),
    portalGroup: 'all.public',
    meta: { authenticated: true, title: '我的訂單記錄' }
  },
  {
    path: '/admin/CashFlowHistory',
    name: 'PgCashFlowHistoryAdmin',
    component: () => import('@/app/M2001Coins/comps/PgAdminCashFlow.vue'),
    props: { adminMode: true },
    portalGroup: 'all.admin',
    meta: { authenticated: true, title: '訂單記錄' }
  }
]
